
/**
 * @param inputSelector (selector to prefix field input type="tel")
 */
function addFlagsDropdown(inputSelector){
    var $originalInputElem = $(inputSelector) ;
    removeFirstPlusChar($originalInputElem) ;
	var classes = $originalInputElem.attr('class').split(' ');
	var lengthValidation ;
	for(var i=0 ; i < classes.length ; i++) {
        if(classes[i].indexOf('swFieldLength') !== -1){
            lengthValidation = parseInt(classes[i].slice(-1)) + 1;
            break ;
        }
    }
    
	$originalInputElem.hide();
    var $flagsInputElem = $('<input maxlength="' + lengthValidation + '" class="swFormControl swbPhoneExtensionField" type="text">') ;
	$originalInputElem.after($flagsInputElem);
    var intlInputConf = {} ;
    var originalVal = $originalInputElem.val() ;
    if(!originalVal){
        intlInputConf.geoIpLookup = function(callback){
            var countryCode = get_user_location();
            callback(countryCode);
        } ;

        intlInputConf.initialCountry = "auto" ;
    }

    if(!!originalVal){
        $flagsInputElem.val("+" + originalVal);
    }

    window.iti = window.intlTelInput($flagsInputElem[0], intlInputConf);

    $flagsInputElem.on('input' , function(){
        addPlusToInput($(this));
        var val = $(this).val() ;
        if(val[0] == '+'){
            val = val.slice(1);
        }
        $originalInputElem.val(val) ;

    }) ;

    $flagsInputElem.on('countrychange' , function() {
        var dialCode = iti.getSelectedCountryData().dialCode;
        var inputValue = $flagsInputElem.val();
        if (typeof dialCode !== 'undefined') {
            $originalInputElem.val(dialCode);

            if (!inputValue) {
                $flagsInputElem.val('+' + dialCode);
            }
        }
    });

    function addPlusToInput(that){
        var inputVal = that.val() ;
        if(inputVal[0] !== '+'){
            that.val('+' + inputVal) ;
        }
    }

    function removeFirstPlusChar($input){
        var inputVal = $input.val() ;
        if(inputVal[0] == '+'){
            inputVal = inputVal.slice(1);
        }
        $input.val(inputVal) ;
    }

    function get_user_location(){

        var country = docCookies.getItem('lang');
        var country_code;

        if (country){
            country_code = country.split("-")[0]
        }

        if(!country_code){
            country_code = 'GB' ;
        }

        return country_code;
    }

    return $flagsInputElem ;
}


/**
 *
 * adds the flags dropdown and takes care of the dependecncy of the country select dropdown to the prefix phone input
 * @param prefixSelector - string selector to the input prefix
 * @param countrySelect - string (optional) to the country select field that when changing prefix it should change country select
 */
function wdAddFlagsPrefixDropdown(prefixSelector , countrySelect){
    var $input = addFlagsDropdown(prefixSelector);

    if(typeof countrySelect !== 'undefined'){
        var $selectElement = $(countrySelect) ;
        var selectElement = $selectElement[0] ;

        $input.on('countrychange' , function(a){
            var b = iti.getSelectedCountryData();
            if(typeof b == 'object' && !!b.iso2){
                var isoCode = b.iso2.toUpperCase() ;
                var selectedOption = $selectElement.find('option[value="'+ isoCode + '"]') ;
                var index = 0 ;
                var currentOption = selectedOption ;
                if(currentOption.length > 0){
                    while(currentOption.prev().length > 0){
                        index++ ;
                        currentOption = currentOption.prev() ;
                    }
                    selectElement.selectedIndex = index ;
                    selectElement.value = isoCode ;
                    flagsDropdownTriggerEventOnElement(selectElement , "change");
                }
            }
        }) ;

        pickPrefixAccordingToCountry($selectElement, $input);
    }

    function pickPrefixAccordingToCountry($countrySelect, $phonePrefixInput) {
        var countryCode = $countrySelect.val().toLowerCase(),
            phonePrefix = $phonePrefixInput.val(),
            $telInput = $phonePrefixInput.closest('.iti');
        
        if (!countryCode) return;

        if (!phonePrefix) {
            phonePrefix = $countrySelect.find('option:selected').attr('phoneprefix');
            $telInput.val(phonePrefix);
        } else {
            var currentCountry;

            $('#country-listbox [data-dial-code="' + phonePrefix.replace('+' , '') + '"]').each(function(){
                var currentCountryCode = $(this).attr('data-country-code').toLowerCase();
                if (currentCountryCode == countryCode){
                    currentCountry = this;
                    return;
                }
            });

            if (currentCountry) {
                wdFlagsSelectList(currentCountry);
            }
        }
    }
}

/**
 *
 * @param native elem to trigger event on
 * @param event string with the name of the event "click"/"change"
 */
function flagsDropdownTriggerEventOnElement(elem , event){
    if ("createEvent" in document) {
        var evt = document.createEvent("HTMLEvents");
        var eventCanceled ;
        evt.initEvent(event, true, false);
        eventCanceled = elem.dispatchEvent(evt);
    }
    else{
        elem.fireEvent("on" + event);
    }
}